/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Legajox_Payroll_ErrorInputs */

const es_tools_legajox_payroll_error = /** @type {(inputs: Tools_Legajox_Payroll_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al consultar recibos de sueldo de Legajox`)
};

const en_tools_legajox_payroll_error = /** @type {(inputs: Tools_Legajox_Payroll_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error querying Legajox payroll`)
};

/**
* | output |
* | --- |
* | "Error querying Legajox payroll" |
*
* @param {Tools_Legajox_Payroll_ErrorInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_legajox_payroll_error = /** @type {((inputs?: Tools_Legajox_Payroll_ErrorInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Legajox_Payroll_ErrorInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_legajox_payroll_error(inputs)
	return en_tools_legajox_payroll_error(inputs)
});
export { tools_legajox_payroll_error as "tools.legajox.payroll_error" }